import React from 'react'

export default props => (
    <td {...props} align={props.alignRight ? 'right' : (props.alignCenter ? 'center' : 'left')} onClick={props.onClick} 
		style={{ 
			...props.style, 
			fontWeight: props.bold ? 'bold' : null, 
			paddingLeft: 2, 
			paddingTop: 2,
			paddingRight: 8, 
			paddingBottom: 2, 
			verticalAlign: 'middle', 
			minWidth: props.minWidth, 
			maxWidth: props.maxWidth,
			fontSize: props.style && props.style.fontSize ? props.style.fontSize : 12,
			backgroungColor: props.backgroungColor
		}} >
		{props.children}
	</td>
)
